import React, { useState, useRef, useEffect } from 'react';
import { Search, Bell, Menu, User, Settings, CreditCard, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';

const TopBar = ({ toggleSidebar }) => {
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [notifications] = useState(3); // Mock notification count
  const profileMenuRef = useRef(null);
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  // Close profile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/signin');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <header className="h-16 bg-gray  border-gray-100 flex items-center justify-between px-6 lg:px-8">
      {/* Left: Mobile Menu + Search */}
      <div className="flex items-center gap-4 flex-1">
        {/* Mobile Menu Button */}
        <button
          onClick={toggleSidebar}
          className="lg:hidden p-2 rounded-xl hover:bg-gray-50 transition-all duration-200 hover:scale-105"
        >
          <Menu size={20} className="text-gray-600" />
        </button>


      </div>

      {/* Right: Notifications + Profile */}
      <div className="flex items-center gap-3">
        {/* Search Icon for Mobile */}
        


        {/* Profile Menu */}
        <div className="relative" ref={profileMenuRef}>
          <button
            onClick={() => setShowProfileMenu(!showProfileMenu)}
            className="flex items-center gap-3 p-1.5 rounded-xl hover:bg-gray-50 transition-all duration-200 group"
          >
            <div className="w-9 h-9 bg-gradient-to-r from-blue-600 to-blue-400 rounded-full flex items-center justify-center border border-transparent group-hover:border-blue-500 transition-all duration-200">
              <User size={18} className="text-black" />
            </div>
            <div className="hidden md:block text-left">
              <p className="text-sm font-semibold text-gray-900">
                {user?.full_name || 'User'}
              </p>
              <p className="text-xs text-gray-500 font-medium">
                {user?.user_type ? user.user_type.charAt(0).toUpperCase() + user.user_type.slice(1) : 'Creator'}
              </p>
            </div>
          </button>

          {/* Dropdown Menu */}
          {showProfileMenu && (
            <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl border border-gray-200 py-2 z-50 backdrop-blur-sm bg-white/95">
              {/* User Info */}
              <div className="px-4 py-3 border-b border-gray-100">
                <p className="text-sm font-semibold text-gray-900">
                  {user?.full_name || 'User'}
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  {user?.email || 'user@example.com'}
                </p>
              </div>
              
              {/* Menu Items */}
              <button className="w-full text-left flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150"
                 onClick={() => {
                   navigate('/dashboard/account');
                   setShowProfileMenu(false);
                 }}
              >
                <User size={16} className="text-gray-400" />
                Profile Settings
              </button>
              <button onClick={() => {
                navigate('/dashboard/account');
                setShowProfileMenu(false);
              }} className="w-full text-left flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150">
                <Settings size={16} className="text-gray-400" />
                Account Preferences
              </button>
              <button onClick={() => {
                navigate('/dashboard/account?section=plan');
                setShowProfileMenu(false);
              }}  className="w-full text-left flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150">
                <CreditCard size={16} className="text-gray-400" />
                Billing & Subscription
              </button>
              
              <hr className="my-2 border-gray-100" />
              
              <button 
                onClick={handleLogout}
                className="w-full text-left flex items-center gap-3 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-colors duration-150"
              >
                <LogOut size={16} />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default TopBar;